'use client';

/**
 * Client wrapper for a geo grid tile on /near-me so we can fire a
 * PostHog `geo_grid_click` event when a user picks a city. Parent is
 * an RSC.
 */

import Link from 'next/link';
import { pushEvent } from '@/lib/analytics/core';

interface Props {
  city: string;
  industry: string;
  href: string;
  className: string;
  children: React.ReactNode;
}

export function GeoGridLink({ city, industry, href, className, children }: Props) {
  return (
    <Link
      href={href}
      onClick={() => pushEvent('geo_grid_click', { city, industry })}
      className={className}
    >
      {children}
    </Link>
  );
}

export default GeoGridLink;
